import { Injectable } from '@angular/core';
import { Router, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { LoginService } from '../shared/services/login.service';
import { GlobalService } from '../shared/services/global.service';

@Injectable({
	providedIn: 'root'
})
export class CanActivateGuard  {
	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return new Promise((resolve, reject) => {
			this._lS.setRedirecUrl(state);
			var a = null
			if (next.data) {
				if (next.data.access) {
					a = next.data.access[0].id
				}
			}
			this._lS.validateSesion(null, a, next.params.id).subscribe(
				(data: any) => {
					if (data.access == 'Session Active') {
						this._gS.setSession(data.token);
						this._lS.removeSessionLv();
						sessionStorage.setItem('pms_us', JSON.stringify(data.user));
						// this._gS.accesKey = data.fs_key;
						// this._gS.secret = data.fs_sec;
						// this._gS.bucket = data.fs_buk;
						this._gS.user = data.user;
						if (!data.pacss && a) {
							resolve(false)
							this.router.navigate(['/home']);
						}
						resolve(true)
					} else {
						this._gS.removeCookies();
						this.router.navigate(['/login']);
						resolve(false)
					}
				}
			)

		})


	}
	constructor(private _cS: CookieService, private _lS: LoginService, private router: Router, public _gS: GlobalService) { }
}
